import React from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { STUDENTS_ASSIGNMENTS_LIST_URL } from 'config/urls';

import { colors } from 'theme/palette';
import { useMenu } from 'utils/hooks';
import { useIsMobile } from 'utils/resizing';

import FreeTrialReminder from 'components/FreeTrialReminder';
import Typography from 'components/Typography';

import { ReactComponent as AccountIcon } from './assets/account.svg';
import { ReactComponent as SignOutIcon } from './assets/sign-out.svg';
import styles from './styles.module.scss';

export const hideSchoolSelectMenuItem = ({
  organizations,
  selectedOrganization
}) => {
  return (
    organizations?.length === 1 && selectedOrganization?.schools.length === 1
  );
};

const AccountMenuButton = ({ user, logout }) => {
  const [anchorEl, openMenu, closeMenu] = useMenu();
  const isMobile = useIsMobile();

  const openStudentApp = () =>
    window.open(STUDENTS_ASSIGNMENTS_LIST_URL, '_blank');

  const showAccountMenuData = !(isMobile && user.is_pathways_user);

  return (
    <>
      <IconButton onClick={openMenu} className={styles.iconButton}>
        <AccountIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        autoFocus={false}
        classes={{ list: styles.menuList, paper: styles.menuPaper }}
        onClose={closeMenu}
      >
        {user.is_in_free_trial && <FreeTrialReminder displayProgress={false} />}
        <MenuItem button={false}>
          <Typography variant="S-TEXT-1" color={colors.blue2}>
            {user.name}
          </Typography>
        </MenuItem>

        <MenuItem onClick={logout}>
          <Typography variant="S-TEXT-1" color={colors.blue2}>
            Sign out
          </Typography>
        </MenuItem>
        {user.is_teacher && user.student_id && showAccountMenuData && (
          <MenuItem onClick={openStudentApp}>
            <div className={styles.studentLink}>
              <Typography variant="S-TEXT-1" color={colors.blue2}>
                Student App
              </Typography>
              <SignOutIcon />
            </div>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default AccountMenuButton;
